<div class="dialog-header">
    <p>Filter Locations</p>
</div>

<mat-dialog-content class="dialog-content">
    <vulcan-location-filter
        (dataChange)="newFeatures = $event"
        [showAggregationLevels]="data.showAggregationLevels"
        [autoSelectAggregationLevel]="data.autoSelectAggregationLevel"
        [autoSelectCodes]="data.autoSelectCodes"
        [showCounties]="data.showCounties"
        [aggregationLevels]="aggregationLevels"
        m2CheckboxColor="primary">
    </vulcan-location-filter>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
    <button mat-flat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="primary" [disabled]="invalid" [mat-dialog-close]="newFeatures">Submit</button>
</mat-dialog-actions>
